function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#393c50"
}, React.createElement("path", {
  d: "M6.111 5L5 6.111l8.887 8.886 1.11-1.11L6.111 5z"
}), React.createElement("path", {
  d: "M15 6.113l-1.111-1.11-8.886 8.886L6.113 15 15 6.113z"
}));

var SvgBespokenXIcon = function SvgBespokenXIcon(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgBespokenXIcon;